import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BulkActivationComponent } from "./bulk-activation.component";
import { BulkActivationTableComponent } from "./bulk-activation-table/bulk-activation-table.component";

export const bulkActivationRoutes =
{
    path: 'bulk-activation', canActivateChild: [AuthGuard], children: [
        { path: '', component: BulkActivationComponent, pathMatch: 'full' },
        { path: 'new-list', component: BulkActivationTableComponent, pathMatch: 'full' },
    ]
}